import {UseQrCodeScannerProps} from './useQrCodeScanner.native';

export const useQrCodeScanner: (props: UseQrCodeScannerProps) => () => void = () => {
  return () => undefined;
};
